// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"TempCheckActionButton_buttonContainer__1yH-b"};